import alt from '../alt';


class CookieActions {
    setCookies(cookies) {
        this.dispatch({cookies});
    }

    setRemoteAddr(remoteAddr) {
        this.dispatch({remoteAddr});
    }

    setUserAgent(userAgent) {
        this.dispatch({userAgent});
    }
}

export default alt.createActions(CookieActions);



/** WEBPACK FOOTER **
 ** ./app/src/actions/CookieActions.js
 **/